'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'psd2_popup_manager',
    modelClass: Backbone.Model.extend({
        connect: true,
        selectors: ['bookingId', 'selectedPaymentMethod'],
        defaults: {
            paymentMethods: [],
        },
    }),
    viewClass: require('./view'),
    methods: {
        toggleWaiting(isVisible) {
            this.toggleWaiting(isVisible);
        },
        toggleIframe(isVisible) {
            this.toggleTemplate('iframe', isVisible);
            this.resizeBox('od-iframe-psd2-container', isVisible);
            this.showIframe3ds();
        },
        toggleIframeFullPage(isVisible) {
            this.toggleTemplate('drawer', isVisible);
            if (Odigeo.SessionScope.flow === 'mobile') {
                setTimeout(() => {
                    this.toggleDrawer(isVisible);
                }, 5000);
            } else {
                this.toggleDrawer(isVisible);
            }
            this.showIframe3ds();
        },
        updatePaymentMethods(paymentMethods) {
            this.model.set('paymentMethods', paymentMethods);
        },
        isVisible() {
            return this.getIsVisible();
        },
        showError() {
            this.showError();
        },
        removeIframeClasses() {
            this.toggleIframeClasses(false);
        },
    },
});
